module.exports = __webpack_public_path__ + "img/maintenance-1.213e1405.png";